export const noEmptyRules = [(v: string) => !!v || "入力してください"];

export const requiredRule = (v: string, t: (key: string) => string) => !!v || t('form.formPages.inputErrors.pleaseInput')

export const MAX_BIRTH_DATE_AGE_YEARS = 130;

export const yearRules = (
  t: (key: string) => string
): Array<(v: string) => boolean | string> => {
  const currentYear = new Date().getFullYear();
  const formatRule = (v: string) =>
    !v || /^\d{4}$/.test(v) || t("form.dateField.invalidYear");

  const birthDateRangeRule = (v: string) =>
    !v ||
    (parseInt(v) <= currentYear && parseInt(v) >= currentYear - MAX_BIRTH_DATE_AGE_YEARS) ||
    t("form.dateField.invalidYear");

  return [ 
    formatRule, 
    birthDateRangeRule
  ];
};

const getDaysInMonth = (year: number, month: number): number => {
  return new Date(year, month, 0).getDate();
};

export const dayRules = (
  t: (key: string) => string
): Array<(v: string, year?: string, month?: string) => boolean | string> => {
  const dayValidationRule = (v: string, year?: string, month?: string) => {
    if (!v) return true;
    
    const day = parseInt(v);
    if (!/^\d{1,2}$/.test(v) || day < 1) {
      return t("form.dateField.invalidDate");
    }
  
    const yearNum = year ? parseInt(year) : new Date().getFullYear();
    const monthNum = month ? parseInt(month) : new Date().getMonth() + 1;
    
    // Get the maximum days for the given month
    const maxDays = getDaysInMonth(yearNum, monthNum);
    
    if (day > maxDays) {
      return t("form.dateField.invalidDate");
    }
  
    return true;
  };

  return [dayValidationRule];
};
